import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, Type} from '@angular/core';
import {NbDialogService} from '@nebular/theme';

export interface DialogContext {
    _selectedValueIds: any[];
    value: any[];
}

@Component({
    selector: 'ngx-dialog-filter-cell',
    templateUrl: './dialog-filter-cell.component.html',
    styleUrls: ['./dialog-filter-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFilterCellComponent<T extends DialogContext> {
    @Input() value: any;
    @Output() filterSaved: EventEmitter<void> = new EventEmitter();
    dataFunction: (formId: number) => any;
    public buttonStyle: string = 'primary';
    public filterFieldName: string = null;
    public valueFieldName: string = null;
    public dialogComponent: Type<T>;
    public selectedValueIds = [];

    constructor(private dialogService: NbDialogService) {}

    openScopeSelectionDialogProcess(): void {
        if (this.value?.id && this.filterFieldName) {
            this.dataFunction(this.value.id).subscribe((res) => {
                this.selectedValueIds = res.response.items.map((item) => item[this.filterFieldName]);
                this.openDialog();
            });
        }
    }

    private openDialog(): void {
        this.dialogService
            .open<DialogContext>(this.dialogComponent, {
                context: {
                    _selectedValueIds: this.selectedValueIds,
                    value: this.value,
                },
                closeOnBackdropClick: false,
            })
            .onClose.subscribe(() => {
                this.filterSaved.emit();
            });
    }

    getValue() {
        if (this.valueFieldName) {
            return this.value[this.valueFieldName];
        } else {
            return null;
        }
    }
}
